<template>
  <div class="formPage">
    <div class="download_btn" @click="downloadResult">下载</div>
    <div
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.4)"
      id="table"
    >
      <div class="order_container">
        <div class="order_detail_wrap flex-between">
          <div class="order_list_wrap one">
            <p>单号</p>
            <p>订单编号</p>
            <p>成单日期</p>
            <p>收件人姓名</p>
            <p>收件人联系方式</p>
            <p>物流类型</p>
            <p>发货物流单号</p>
          </div>
          <div class="order_list_wrap two">
            <p>{{ dataItem.orderid }}</p>
            <p>{{ dataItem.orderno }}</p>
            <p>{{ dataItem.createdate }}</p>
            <p>{{ dataItem.truename }}</p>
            <p>{{ dataItem.cellphone }}</p>
            <p>{{ dataItem.service_company }}</p>
            <p>{{ dataItem.service_no }}</p>
          </div>
          <div class="order_list_wrap three">
            <div class="ercode_wrap flex-rowc">业务码：暂无功能</div>
            <p>执行业务员：</p>
          </div>
        </div>
        <div class="order_shop_wrap">
          <div class="tit">订单商品信息</div>
          <div class="order_shop_head flex-rowl">
            <p class="item one">商品名称</p>
            <p class="item two">商品SKUID</p>
            <p class="item three">订单内类型</p>
            <p class="item four">商品属性标签</p>
            <p class="item five">商品数量</p>
            <p class="item six">配货信息</p>
            <p class="item seven">物流包装规格</p>
          </div>
          <div class="order_shop_body">
            <div
              class="order_shop_list flex-between"
              v-for="(item, index) in orderShopList"
              :key="index"
            >
              <div class="item one flex-rowc">{{ item.cmname }}</div>
              <div class="item two flex-rowc">{{ item.sku }}</div>
              <div class="item three flex-rowc">
                {{ item.ismain ? "主商品" : "配件" }}
              </div>
              <div class="item four flex-rowc">{{ item.attr }}</div>
              <div class="item five flex-rowc">{{ item.cmnum }}</div>
              <div class="item six flex-rowc">{{ item.msg }}</div>
              <div class="item seven flex-rowc">
                <p class="flex-rowc">{{ item.spec }}</p>
                <p class="flex-rowc">{{ item.spec_ext }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { encryptstringview } from "../../api/api";
import { getLogisticsDetail, getLogisticsDisList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundItemForm",
  data() {
    return {
      loading: false,

      dataItem: "",
      orderShopList: "", // 商品配货列表
      orderShopParams: {
        wsid: "",
        pageindex: 1,
        pagesize: 50,
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        // this.getLogisticsDetail(id);
        this.orderShopParams.wsid = id;
        this.init(id);
      } else {
        this.$router.back();
      }
    },

    getLogisticsDetail(id) {
      this.loading = true;
      getLogisticsDetail({ id }).then((res) => {
        this.dataItem = res;
        this.shopList = JSON.parse(res.details);
        this.loading = false;
      });
    },

    async init(id) {
      this.loading = true;
      // 订单数据
      let res1 = await getLogisticsDetail({ id });
      this.dataItem = res1;

      // 订单商品
      let res2 = await getLogisticsDisList(this.orderShopParams);

      this.orderShopList = res2.list;

      this.loading = false;
    },

    handleReturn() {
      this.$router.back();
    },

    dataURLToBlob(dataurl) {
      //ie 图片转格式
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    downloadResult() {
      let canvasID = document.querySelector("#table");
      let a = document.createElement("a");
      html2canvas(canvasID).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        a.style.display = "none";
        document.body.removeChild(dom);
        let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
        window.open(URL.createObjectURL(blob), "_blank");
        // a.setAttribute("href", URL.createObjectURL(blob));
        // a.setAttribute("download", name + ".png");
        // document.body.appendChild(a);
        // a.click();
        // URL.revokeObjectURL(blob);
        // document.body.removeChild(a);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.formPage {
  padding: 15px 3%;
  .download_btn {
    background: #6e5c86;
    // padding: 5px 20px;
    display: inline-block;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
  }
  #table {
    padding: 20px;
    font-size: 14px;
    width: 1290px;
    min-height: 920px;
    box-sizing: border-box;
    margin: auto;
    .order_container {
      border: 1px solid #5c5c5c;

      .order_detail_wrap {
        .order_list_wrap {
          white-space: nowrap;

          &.one {
            width: 25%;
            font-weight: bold;
          }
          &.two {
            width: 45%;
            border-left: 1px solid #5c5c5c;
            border-right: 1px solid #5c5c5c;
          }
          &.three {
            width: 30%;
            .ercode_wrap {
              height: 240px;
              border-bottom: 1px solid #5c5c5c;
            }
            p {
              text-align: center;
            }
          }
          p {
            height: 40px;
            line-height: 40px;
            padding: 0 10px;
            border-bottom: 1px solid #5c5c5c;
            box-sizing: border-box;
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
    .order_shop_wrap {
      .tit {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-bottom: 1px solid #5c5c5c;
        border-top: 1px solid #5c5c5c;
      }
      .order_shop_head {
        font-weight: bold;
        border-bottom: 1px solid #5c5c5c;
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;
      }
      .order_shop_body {
        .order_shop_list {
          border-bottom: 1px solid #5c5c5c;
          &:last-child {
            border-bottom: none;
          }
          .item {
            // padding: 0 10px;
            min-height: 65px;
            line-height: 18px;
          }
        }
      }
      .item {
        // height: 40px; 
        // line-height: 40px;
        text-align: center;
        flex-shrink: 0;
        border-right: 1px solid #5c5c5c;
        box-sizing: border-box;
        &.one {
          width: 13%;
        }
        &.two {
          width: 11%;
        }
        &.three {
          width: 11%;
        }
        &.four {
          width: 20%;
        }
        &.five {
          width: 7%;
        }
        &.six {
          width: 22%;
        }
        &.seven {
          width: 16%;
          border-right: none;
          p {
            flex-shrink: 0;
            width: 50%;
            height: 100%;
            &:last-child {
              border-left: 1px solid #5c5c5c;
            }
          }
        }
      }
    }
  }
}
</style>